import { useState, useEffect } from 'react';
import {
    Typography,
    Box,
    Link,
    Tooltip,
    IconButton,
    Chip
} from '@mui/material';
import styles from './view-card.module.scss';
import { CallCalling, ExportSquare, MessageText1, Sms } from 'iconsax-react';
import dayjs from 'dayjs';
import { getPhoneNumberWihKey } from '../../utils/profile-utils';

const ViewInfo = ({ label, uiStore }) => {
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [location, setLocation] = useState({ lat: 10, lng: 10, zoom: 1 });
    const [availability, setAvailability] = useState(null);
    const days = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

    useEffect(() => {
        async function fetchAddress() {

            if (label.infoType === "address") {
                setCountry(label.info?.country);
                setState(label.info?.state);
                setCity(label.info?.city);
            }

            if (label.infoType === "location") {
                const newLocation = JSON.parse(label.info.infoValue);
                setLocation(newLocation);
            }

            if (label.infoType === 'day-time' && !availability) {
                const ava = await uiStore.getAvailability(label.info?.infoValue);
                setAvailability(ava);
            }

        }

        fetchAddress()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [label, uiStore])


    if (label.infoType === 'address') {
        return (
            <>
                {country &&
                    <Box className={styles.viewLabel}>
                        <Typography fontSize={14} color='#888' className={styles.label}>Country</Typography>
                        <Typography fontSize={14} fontWeight={600}>{country}</Typography>
                    </Box>
                }
                {state &&
                    <Box className={styles.viewLabel}>
                        <Typography fontSize={14} color='#888' className={styles.label}>State</Typography>
                        <Typography fontSize={14} fontWeight={600}>{state}</Typography>
                    </Box>
                }
                {city &&
                    <Box className={styles.viewLabel}>
                        <Typography fontSize={14} color='#888' className={styles.label}>City</Typography>
                        <Typography fontSize={14} fontWeight={600}>{city}</Typography>
                    </Box>
                }
            </>
        );
    }

    else if (label.infoType === 'day-time' && availability) {
        return (
            <Box>
                {availability.status === 'open' &&
                    <Box>
                        {days.map(day =>
                            <Box key={day} className={styles.avaBox}>
                                <Typography fontSize={14} color='#888'>{day}</Typography>
                                Open
                            </Box>
                        )}
                    </Box>
                }
                {availability.status === 'closed' &&
                    <Box >
                        {days.map(day =>
                            <Box key={day} className={styles.avaBox}>
                                <Typography fontSize={14} color='#888'>{day}</Typography>
                                Closed
                            </Box>
                        )}
                    </Box>
                }
                {availability.status === 'custom' &&
                    <Box>
                        {days.map(day =>
                            <Box key={day} className={styles.avaBox}>
                                <Typography fontSize={14} color='#888'>{day}</Typography>
                                {dayjs(availability[day]['from']).format('hh:mm A')} - {dayjs(availability[day]['to']).format('hh:mm A')}
                            </Box>
                        )}
                    </Box>
                }
            </Box>
        )
    }
    else {
        return (
            <Box className={styles.viewLabel}>
                <Typography fontSize={14} color='#888' className={styles.label}>{label.name}</Typography>
                {label.multipleValues ?
                    <>
                        {label.info.infoValues?.map(item => (
                            <Chip
                                key={label.info._id + item}
                                color='lightblue'
                                sx={{ mr: 1 }}
                                size='small'
                                label={
                                    <Typography fontSize='12px' fontWeight={600}>
                                        {item}
                                    </Typography>
                                }
                            />
                        ))}
                    </>
                    : <Typography fontSize={14} fontWeight={600} sx={{ maxWidth: 'fit-content', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        {label.infoType === 'location' &&
                            <Link
                                href={`https://www.google.com/maps/search/?api=1&query=${location?.lat},${location?.lng}`}
                                target="_blank"
                                rel='noopener noreferrer'
                            >

                                View Location
                                <ExportSquare
                                    size="18"
                                    variant="Outline"
                                />
                            </Link>
                        }

                        {label.infoType === 'URL' &&
                            <Link
                                href={label.info.infoValue}
                                target="_blank"
                                rel='noopener noreferrer'
                                sx={{ maxWidtha: '50%' }}
                            >
                                {label.info.infoValue}
                            </Link>
                        }

                        {label.infoType === 'date' &&
                            <>
                                {label.infoLabel === 'Birthday' ?
                                    dayjs(label.info?.infoValue).format('dddd, MMM D')
                                    :
                                    dayjs(label.info?.infoValue).format('ddd D, MMM YYYY')
                                }
                            </>
                        }

                        {label.infoType === 'number' &&
                            <>
                                {getPhoneNumberWihKey(label.info)}
                                <Tooltip title="Call">
                                    <IconButton
                                        href={'tel:' + getPhoneNumberWihKey(label.info)}
                                        sx={{ width: '36px', ml: 2 }}
                                    >
                                        <CallCalling size="24" variant="Bulk" color='#02B28E' />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Text">
                                    <IconButton
                                        href={'sms:' + getPhoneNumberWihKey(label.info)}
                                        sx={{ width: '36px' }}
                                    >
                                        <MessageText1 size="24" variant="Bulk" color='#02B28E' />
                                    </IconButton>
                                </Tooltip>
                            </>
                        }

                        {label.infoType !== 'number' && label.infoType !== 'date' && label.infoType !== 'location' && label.infoType !== 'day-time' &&
                            label.infoType !== 'URL' &&
                            <>{label.info?.infoValue}</>
                        }

                        {label.infoType === 'email' &&
                            <Tooltip title="Send Email">
                                <IconButton
                                    href={'mailto:' + label.info?.infoValue}
                                    sx={{ width: '36px', ml: 2 }}
                                >
                                    <Sms size="24" variant="Bulk" color='#02B28E' />
                                </IconButton>
                            </Tooltip>
                        }

                    </Typography>
                }
            </Box>
        );
    }

}
export default ViewInfo;